module.exports = __webpack_public_path__ + "static/media/checkitoff-macbook-add-event.6d9717e2.jpg";